import _sfc_main from "./devtools.vue.js";
const VueQueryDevtools = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : _sfc_main;
export {
  VueQueryDevtools
};
//# sourceMappingURL=index.js.map
